import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogAssignComponent } from '../dialog-assign/dialog-assign.component';
import { OrderDetailComponent } from '../order-detail/order-detail.component';
import { Router } from '@angular/router';
import { OrderService, OrdersListDto } from 'src/generated_client';
import { SnackBarService } from 'src/app/services/snack-bar.service';

@Component({
  selector: 'app-active-orders',
  templateUrl: './active-orders.component.html',
  styleUrls: ['./active-orders.component.css']
})
export class ActiveOrdersComponent implements OnInit {

  displayedColumns: string[] = ['codigo', 'tienda', 'usuario', 'direccion', 'items', 'total', 'estado', 'opciones'];

  allActive: OrdersListDto[] = [];
  id: any;


  constructor(
    public dialog: MatDialog,
    private router: Router,
    private orderService: OrderService,
    private snackBar: SnackBarService
  ) { }

  ngOnInit(): void {
    this.orderService.apiOrderGetAllActiveGet().subscribe(x => {
      this.allActive = x;
      this.allActive.sort((a, b) => (a.dtOrderDate! > b.dtOrderDate!) ? 1 : -1);
    })
  }

  assignDelivery(id: number) {
    this.dialog.open(DialogAssignComponent);
  }
  open(id: number) {
    let order = this.allActive.find(x => x.cdOrder);
    let items = order?.itemInOrderOutputDtos;
    this.dialog.open(OrderDetailComponent, {
      data: {
        items: items,
        delivery: order?.qtDCharges,
        discount: order?.qtDiscount,
        total: order?.qtTotal,
        notes: order?.dsNotes
      }
    });
  }

  rejectOrder(id: number) {
    this.orderService.apiOrderRejectOrderPut(id).subscribe(response => {
      this.snackBar.openSnackBar("Orden Rechazada", "Aceptar");
      this.router.navigate(['active-orders'])
    }, err => {
      this.snackBar.openSnackBar(err.error.error, 'Aceptar');
    })
  }


  acceptOrder(id: number) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.orderService.apiOrderConfirmOrderPut(id).subscribe(response => {
      this.snackBar.openSnackBar("Orden Aceptada", "Aceptar");
      this.router.navigate(['active-orders'])
    },
      err => {
        this.snackBar.openSnackBar(err.error.error, "Aceptar")
      }
    );

  }


  OnTheWay(id: number) {
    this.orderService.apiOrderOnTheWayPut(id).subscribe(() => {
      this.router.navigate(['active-orders']);
      this.snackBar.openSnackBar("El estado del pedido fue cambiado correctamente", 'Aceptar');
    },
      err => {
        this.snackBar.openSnackBar("Se produjeron errores al modificar orden", 'Aceptar');
      });
  }

  printOrder() {
    this.router.navigate(['order-receipt']);
  }

}



